export default __webpack_public_path__ + "static/media/under-construction.86897107.gif";